const PhotosHero = () => {
  return (
    <section className="pt-32 pb-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-2 bg-gray-100 rounded-full text-xs font-medium text-gray-600 uppercase tracking-wider mb-6">
            Portfolio
          </span>
          <h1 className="text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6" style={{ fontFamily: 'serif' }}>
            ONZE<br />
            PROJECTEN
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Ontdek onze transformaties en zie hoe we ruimtes omtoveren tot prachtige, functionele leefomgevingen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PhotosHero;